module.exports = __webpack_public_path__ + "static/media/language.9ad71a00.svg";